// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2bG7i","notes":"Notes_notes__3xp0V","note":"Notes_note__3EKTj","markdown":"Notes_markdown__1AHRD"};